import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const HomeRenovationLoan = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-osvezitev-doma.png" xPos="27%" yPos="14%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Osvežite svoj dom brez skrbi!</h1>
                    <p className="text-left">
                      Prenova doma prinese svežino, a tudi nepričakovane stroške.                      
                    </p>
                    <p className="text-left red-text">
                      Z Addiko kreditom lahko preuredite svoj dom po svojih željah brez finančnih preglavic. 
                    </p>
                    <p className="text-left">
                      Vas zanima več? <b>Izpolnite obrazec in kmalu vas bomo poklicali.</b> 
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="a247eab1-e16a-45fa-b2c9-53a7dca8f4b6" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}